import classNames from "classnames";
import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const AccVirtualDigitalAssets: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      {values.TotalVirtualDigitalAsset ? (
        <>
          <Accordion.Item eventKey="income-source-6">
            <ContextAwareToggle eventKey="income-source-6" isChild={true}>
              <div className="btn-content justify-content-between">
                <p className="leading-para fw-bold mb-0">Virtual Digital Assets (VDA)</p>
                <p className="leading-para fw-bold mb-0">
                  <PriceDisplay price={values.TotalVirtualDigitalAsset} />
                </p>
              </div>
            </ContextAwareToggle>
            <Accordion.Body>
              <section>
                <dl className="eds-list eds-dl eds-inline-between">
                  <RenderListItem
                    title="Crypto Income"
                    amount={values.VirtualDigitalAssets.TotalCryptoIncome}
                  />

                  <RenderListItem
                    title="Total:"
                    amount={values.TotalVirtualDigitalAsset}
                    isSubtotal={true}
                  />
                </dl>
              </section>
            </Accordion.Body>
          </Accordion.Item>
        </>
      ) : null}
    </>
  );
};

export default AccVirtualDigitalAssets;

const RenderListItem = ({
  amount,
  title,
  isSubtotal = false
}: {
  amount: number;
  title: string;
  isSubtotal?: boolean;
}) => {
  return (
    <>
      {amount ? (
        <div className={classNames("eds-list--item", isSubtotal && "eds-list--item-subtotal")}>
          <dt>{title}</dt>
          <dd>
            <PriceDisplay price={amount} />
          </dd>
        </div>
      ) : null}
    </>
  );
};
